<template>
    <footer class="footer">
        <BContainer fluid>
            <BRow>
                <BCol col sm="6">
                    &copy; 2026 Cafeman. Seluruh Hak Cipta Dilindungi.
                </BCol>
            </BRow>
        </BContainer>
    </footer>
</template>
